module.exports = __webpack_public_path__ + "img/testEngineer.00572761.png";